export default "__VITE_ASSET__BO6VI3Dk__"